import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from '../../store';
import {
  ChatIconSize,
  ChatLauncherStyleType
} from '../../store/chatSetting/types';

import StyleA from './StyleA';
import StyleB from './StyleB';
import StyleC from './StyleC';

interface IProps {
  showChatBot: any;
  setToggle?: any;
  toggleCloseDialog: any;
}

export interface IChatBotLauncher {
  showChatBot: () => void;
  toggleCloseDialog: () => void;
  baseFontSize: number;
  color: string;
  launcherImageUrl: string;
  isMobile: boolean;
}

const ChatBotLauncher: React.FC<IProps> = ({
  showChatBot,
  toggleCloseDialog
}) => {
  const chatSetting = useSelector((state: AppState) => state.chatSetting);
  const color = chatSetting.mainColor;
  const size = chatSetting.iconSize;
  const launcherImageUrl = chatSetting.launcherImage;

  const ua = navigator.userAgent;
  let isMobile = false;
  if (
    (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) &&
    ua.indexOf('Mobile') > 0
  ) {
    isMobile = true;
  }

  const launcherStyleType = chatSetting.launcherStyleType;

  const getBaseFontSize = (size: ChatIconSize) => {
    switch (size) {
      case ChatIconSize.LARGE:
        return 14;
      case ChatIconSize.MEDIUM:
        return 12;
      case ChatIconSize.SMALL:
      default:
        return 10;
    }
  };
  let baseFontSize = getBaseFontSize(size);
  if (isMobile) {
    baseFontSize = getBaseFontSize(ChatIconSize.SMALL);
  }
  switch (launcherStyleType) {
    case ChatLauncherStyleType.StyleA:
      return (
        <StyleA
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
        />
      );
    case ChatLauncherStyleType.StyleB:
      return (
        <StyleB
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
        />
      );
    case ChatLauncherStyleType.StyleC:
      return (
        <StyleC
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
        />
      );
    default:
      return (
        <StyleA
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
        />
      );
  }
};

export default ChatBotLauncher;
